<script lang="ts">
	import { base } from '$app/paths';
	import { siteTitle } from '$lib/stores/nav';
	import { onMount } from 'svelte';

	export let data;

	onMount(() => {
		$siteTitle = 'Barrierefreiheit';
	});
</script>

<div class="mt-4">
	<h1 class="text-4xl mb-10">Barrierefreiheit</h1>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<p class="col-span-2 rte">
			Die Wienbibliothek im Rathaus ist bemüht, ihre Websites im Einklang mit dem
			Web-Zugänglichkeits-Gesetz (WZG) zur Umsetzung der <a
				href="https://eur-lex.europa.eu/legal-content/DE/TXT/?uri=CELEX:32016L2102"
				>Richtlinie (EU) 2016/2102 des Europäischen Parlaments und des Rates vom 26. Oktober
				2016 über den barrierefreien Zugang zu den Websites und mobilen Anwendungen
				öffentlicher Stellen</a
			> (ABl. L 327 vom 2.12.2016, S. 1) barrierefrei zugänglich zu machen.
		</p>

		<p class="col-span-2">
			Diese Erklärung zur Barrierefreiheit gilt für die Domain:
			wienbibliothek.crowdsourcing.wien{base}
		</p>
	</section>
	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Stand der Vereinbarkeit mit den Anforderungen</h2>
		<div class="rte">
			<p>
				Diese Website ist wegen der folgenden Unvereinbarkeiten und/oder Ausnahmen teilweise
				mit <strong>Konformitätsstufe AA</strong> der "<a
					href="https://www.w3.org/TR/WCAG21/"
					>Richtlinien für barrierefreie Webinhalte Web - WCAG 2.1</a
				>" entsprechend der geltenden harmonisierten europäischen Norm "Europäischer
				Standard EN 301 549 V3.2.1 (2021-03)" vereinbar.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Nicht barrierefreie Inhalte</h2>
		<div class="rte">
			<p>
				Die Crowdsourcing-Website der Wienbibliothek im Rathaus entspricht dem aktuellen
				Stand der Technik. Die barrierefreie Gestaltung der Inhalte und Funktionen wird auf
				dieser Grundlage schrittweise weiterentwickelt.
			</p>
			<p>
				Die nachstehend angeführten Inhalte sind aus den folgenden Gründen nicht
				barrierefrei:
			</p>
			<ol class="list-[lower-alpha] pl-[2ch] space-y-[1lh]">
				<li>
					Unvereinbarkeit mit dem Wiener Antidiskriminierungsgesetz LGBl. 35/2004 idgF zur
					Umsetzung der Richtlinie (EU) 2016/2102

					<ol class="list-[decimal] pl-[2ch] space-y-[1lh] mt-[1lh]">
						<li>
							Einzelne Textteile haben einen zu geringen Kontrast zu ihrem Hintergrund
							(WCAG-Kriterium 1.4.3).
						</li>
						<li>
							Einigen Bildern und Buttons sind keine Alternativtexte hinterlegt oder
							der Alternativtext enthält keine Beschreibung des konkreten Bildes
							(WCAG-Kriterium 1.1.1).
						</li>
						<li>
							Manche Unterseiten haben keinen Header (WCAG-Kriterium 1.3.1 und 2.4.6).
						</li>
						<li>
							Manche Eingabefelder besitzen keine Form-Labels (WCAG-Kriterium 1.3.1,
							2.4.6 und 3.3.2).
						</li>
					</ol>
				</li>
				<li>Unverhältnismäßige Belastung</li>
			</ol>
			<p>
				Die Plattform dient der gemeinschaftlichen Erschließung und Transkription
				historischer Quellen.
			</p>
			<p>
				Die zugrunde liegenden Digitalisate stammen aus historischen Beständen und weisen
				teilweise dieselben Einschränkungen auf wie jene im System
				<a href="https://digital.wienbibliothek.at/">digital.wienbibliothek.at</a>,
				insbesondere hinsichtlich fehlender oder eingeschränkter maschineller Texterkennung
				bei Handschriften und Theaterzetteln.
			</p>
			<p>
				Eine vollständige manuelle Nachbearbeitung sowie eine durchgängige barrierefreie
				Aufbereitung aller zugrunde liegenden historischen Quellen würde aufgrund des
				Umfangs und der Materialvielfalt eine unverhältnismäßige Belastung darstellen.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Erstellung dieser Erklärung zur Barrierefreiheit</h2>
		<div class="rte">
			<p>
				Diese Erklärung wurde am 23.06.2026 erstellt. Sie wurde auf Grundlage einer von der
				Wienbibliothek im Rathaus durchgeführten Selbstbewertung erstellt.
			</p>
			<p>Die Erklärung wurde zuletzt am 23.06.2026 überprüft.</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Feedback und Kontaktangaben</h2>
		<div class="rte">
			<p>
				Sollten Ihnen Mängel oder Barrieren auffallen, so bitten wir Sie, uns diese per
				E-Mail an <a href="mailto:crowdsourcing@wienbibliothek.at"
					>crowdsourcing@wienbibliothek.at</a
				> unter Angabe der URL der betroffenen Website oder des betroffenen Dokuments und
				einer Beschreibung des Problems mitzuteilen, damit wir unser Angebot entsprechend
				anpassen und weiter verbessern können.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Durchsetzungs&shy;verfahren</h2>
		<div class="rte">
			<p>
				Bei nicht zufriedenstellenden Antworten der Wienbibliothek im Rathaus können Sie
				sich mittels Beschwerde an die Stelle zur Bekämpfung von Diskriminierungen der Stadt
				Wien wenden. Die Stelle zur Bekämpfung von Diskriminierungen nimmt über das
				Kontaktformular Beschwerden auf elektronischem Weg entgegen.
			</p>
			<p>
				<a
					href="https://www.wien.gv.at/formularserver4/user/formular.aspx?pid=243b95371900481e9ed1335ccec6a26a&pn=B2d555436411c4af58b94491f3869a470&lang=de&datamode=urlenc&data=jd+/fAyuFq9ad6o33tNIaxWO7kXVCVtpXkcnmJ5xfVIBca0j12WriBbbF1Fr6c9KlBHUhnJKZVRahiQDNwMBzckIl7CMCKxaeYtZ0y/KAg+EOJMfhpXbyItekXofTWYl9mNw4amJL6dkscbxV6iJ2wuGLF7zFMicoARcJ+0hf5BdPyh5EF56Od+fObN9rObrFy97HRQthPFQy/8hGfWH7g=="
					>Kontaktformular der Stelle zur Bekämpfung von Diskriminierungen</a
				>
			</p>
			<p>
				Diese Beschwerden werden von der Stelle zur Bekämpfung von Diskriminierungen
				dahingehend geprüft, ob sie sich auf Verstöße gegen die Vorgaben des Wiener
				Antidiskriminierungsgesetzes, insbesondere Mängel bei der Einhaltung der
				Barrierefreiheitsanforderungen, durch das Land oder die Gemeinde Wien oder einer dem
				Land oder der Gemeinde Wien zuordenbaren Einrichtung beziehen.
			</p>
			<p>
				Bei berechtigten Beschwerden hat die Stelle zur Bekämpfung von Diskriminierungen
				gegenüber der betroffenen Dienststelle der Stadt Wien beziehungsweise gegenüber den
				betroffenen Rechtsträgern Handlungsempfehlungen auszusprechen und Maßnahmen
				vorzuschlagen, die der Beseitigung der vorliegenden Mängel dienen.
			</p>
			<p>
				<a href="https://www.wien.gv.at/zusammenleben/barrierefreie-websites"
					>Weitere Informationen zum Beschwerdeverfahren</a
				>
			</p>
			<p>
				Sind Sie von einer vermuteten Diskriminierung im Hinblick auf mangelnde
				Barrierefreiheit selbst betroffen, unterstützt Sie die Stelle zur Bekämpfung von
				Diskriminierungen durch Information und Beratung über Möglichkeiten der
				Rechtsverfolgung.
			</p>
		</div>
	</section>
</div>
